import { render } from "./formLogin.vue?vue&type=template&id=64eadb0d&ts=true"
import script from "./formLogin.vue?vue&type=script&lang=ts"
export * from "./formLogin.vue?vue&type=script&lang=ts"

import "./formLogin.vue?vue&type=style&index=0&id=64eadb0d&lang=css"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__